import { scheduledOrdersSlice } from '../slices/scheduledOrders';
import { Order } from '@interfaces/OrderTypes';
import { useAppDispatch, useAppSelector } from '..';

export const useScheduledOrdersFromStore = () => {
  return useAppSelector((state) => state.scheduledOrders);
};

export const useScheduledOrdersCount = () => {
  return useAppSelector((state) => state.scheduledOrders.count);
};

export const useScheduledOrdersActions = () => {
  const dispatch = useAppDispatch();

  const initScheduledOrders = (orders: Order[]) => dispatch(scheduledOrdersSlice.actions.initScheduledOrders(orders));

  const addScheduledOrder = (order: Order) => dispatch(scheduledOrdersSlice.actions.addScheduledOrder(order));

  const removeScheduledOrder = (orderId: string) =>
    dispatch(scheduledOrdersSlice.actions.removeScheduledOrder(orderId));

  return { initScheduledOrders, addScheduledOrder, removeScheduledOrder };
};
